module.exports = __webpack_public_path__ + "img/MANUEL ANTUNES.5a55e5f6.jpg";